import EventIndex from '@/pages/admin/events/Index.vue'
import EventNew from '@/pages/admin/events/New.vue'
import EventEdit from '@/pages/admin/events/Edit.vue'
import EventShow from '@/pages/admin/events/Show.vue'
import MediaIndex from '@/pages/admin/media/index.vue'
import AdminIndex from '@/pages/admin/Index.vue'
import MessageIndex from '@/pages/admin/messages/Index.vue'
import MessageNew from '@/pages/admin/messages/New.vue'
import MessageShow from '@/pages/admin/messages/Show.vue'
import UserEdit from '@/pages/admin/users/Edit.vue'
import UserIndex from '@/pages/admin/users/Index.vue'
import UserTopics from '@/pages/admin/users/Topics.vue'
import NotFound from '@/pages/NotFound.vue'
import Login from '@/pages/admin/Login.vue'
import NewsIndex from '@/pages/admin/news/Index.vue'
import NewsEdit from '@/pages/admin/news/Edit.vue'
import NewsNew from '@/pages/admin/news/New.vue'
import LifeIndex from '@/pages/admin/lives/Index.vue'
import LifeNew from '@/pages/admin/lives/New.vue'
import LifeEdit from '@/pages/admin/lives/Edit.vue'
import StaffBlogIndex from '@/pages/admin/staff_blogs/Index.vue'
import StaffBlogNew from '@/pages/admin/staff_blogs/New.vue'
import StaffBlogEdit from '@/pages/admin/staff_blogs/Edit.vue'
import AdviceIndex from '@/pages/admin/advices/Index.vue'
import AdviceNew from '@/pages/admin/advices/New.vue'
import AdviceEdit from '@/pages/admin/advices/Edit.vue'
import InterviewIndex from '@/pages/admin/interviews/Index.vue'
import InterviewEdit from '@/pages/admin/interviews/Edit.vue'
import InterviewNew from '@/pages/admin/interviews/New.vue'
import RecruitIndex from '@/pages/admin/recruits/Index.vue'
import RecruitEdit from '@/pages/admin/recruits/Edit.vue'
import RecruitNew from '@/pages/admin/recruits/New.vue'
import JobIndex from '@/pages/admin/jobs/index.vue'
import RecommendIndex from '@/pages/admin/recommends/Index.vue'
import RecommendNew from '@/pages/admin/recommends/New.vue'
import RecommendShow from '@/pages/admin/recommends/Show.vue'
import RecommendEdit from '@/pages/admin/recommends/Edit.vue'
import ApplicantIndex from '@/pages/admin/applicants/Index.vue'
import EventPageIndex from "@/pages/admin/event_pages/Index.vue"
import EventPageNew from "@/pages/admin/event_pages/New.vue"
import EventPageEdit from "@/pages/admin/event_pages/Edit.vue"
import NewJobsIndex from "@/pages/admin/new_jobs/Index.vue"
import NewJobsNew from "@/pages/admin/new_jobs/New.vue"
import NewJobsEdit from "@/pages/admin/new_jobs/Edit.vue"
import KnowHowsIndex from "@/pages/admin/know_hows/Index.vue"
import KnowHowsNew from "@/pages/admin/know_hows/New.vue"
import KnowHowsEdit from "@/pages/admin/know_hows/Edit.vue"

export default [
  {
    path: '/admin',
    component: AdminIndex,
    children: [
      {
        path: 'recruits',
        component: RecruitIndex
      },
      {
        path: 'recruits/new',
        component: RecruitNew
      },
      {
        path: 'recruits/:id/edit',
        component: RecruitEdit
      },
      {
        path: 'advices',
        component: AdviceIndex
      },
      {
        path: 'advices/new',
        component: AdviceNew
      },
      {
        path: 'advices/:id/edit',
        component: AdviceEdit
      },
      {
        path: 'news',
        component: NewsIndex
      },
      {
        path: 'news/new',
        component: NewsNew
      },
      {
        path: 'news/:id/edit',
        component: NewsEdit
      },
      {
        path: 'lives',
        component: LifeIndex
      },
      {
        path: 'lives/new',
        component: LifeNew
      },
      {
        path: 'lives/:id/edit',
        component: LifeEdit
      },
      {
        path: 'staff_blogs',
        component: StaffBlogIndex
      },
      {
        path: 'staff_blogs/new',
        component: StaffBlogNew
      },
      {
        path: 'staff_blogs/:id/edit',
        component: StaffBlogEdit
      },
      {
        path: 'new_jobs',
        component: NewJobsIndex
      },
      {
        path: 'new_jobs/new',
        component: NewJobsNew
      },
      {
        path: 'new_jobs/:id/edit',
        component: NewJobsEdit
      },
      {
        path: 'know_hows',
        component: KnowHowsIndex
      },
      {
        path: 'know_hows/new',
        component: KnowHowsNew
      },
      {
        path: 'know_hows/:id/edit',
        component: KnowHowsEdit
      },
      {
        path: 'interviews',
        component: InterviewIndex
      },
      {
        path: 'interviews/new',
        component: InterviewNew
      },
      {
        path: 'interviews/:id/edit',
        component: InterviewEdit
      },
      {
        path: 'media',
        component: MediaIndex
      },
      {
        path: 'users',
        component: UserIndex
      },
      {
        path: 'users/:id/edit',
        component: UserEdit
      },
      {
        path: 'users/:id',
        component: UserTopics
      },
      {
        path: 'users/:id/topics',
        component: UserTopics
      },
      {
        path: 'event_pages',
        component: EventPageIndex
      },
      {
        path: 'event_pages/new',
        component: EventPageNew
      },
      {
        path: 'event_pages/:id/edit',
        component: EventPageEdit
      },
      {
        path: 'events',
        component: EventIndex
      },
      {
        path: 'events/new',
        component: EventNew
      },
      {
        path: 'events/:id/edit',
        component: EventEdit
      },
      {
        path: 'events/:id',
        component: EventShow
      },
      {
        path: 'users/:id',
        component: UserTopics
      },
      {
        path: 'users/:id/topics',
        component: UserTopics
      },
      {
        path: 'messages',
        component: MessageIndex
      },
      {
        path: 'messages/new',
        component: MessageNew
      },
      {
        path: 'messages/:id',
        component: MessageShow
      },
      {
        path: 'jobs',
        component: JobIndex
      },
      {
        path: 'recommends',
        component: RecommendIndex
      },
      {
        path: 'recommends/new',
        component: RecommendNew
      },
      {
        path: 'recommends/:id',
        component: RecommendShow
      },
      {
        path: 'recommends/:id/edit',
        component: RecommendEdit
      },
      {
        path: 'applicants',
        component: ApplicantIndex
      },
    ]
  },
  {
    path: '/admin/login',
    component: Login
  },
  {
    path: 'not_found',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: '404'
    }
  },
  {
    path: '*',
    redirect: {
      name: 'NotFound'
    }
  }
]
